module.exports = __webpack_public_path__ + "static/media/11.3ef23c1e.JPG";